<template>
  <div class="provider-card uk-link" @click="$emit('click', providerItem)">
    <img :src="providerItem.image" alt="" class="provider-card__image">
    <div class="provider-card__content">
      <div class="provider-card__info">
        <span class="provider-card__category">{{ providerItem.provider }}</span>
      </div>
      <h3 class="provider-card__title">{{ providerItem.title }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProviderCard",
  props: {
    providerItem: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.provider-card {
  display: block;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  height: 100%;
  cursor: pointer;
}

.provider-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.provider-card__image {
  width: 100%;
  height: 160px;
  object-fit: cover;
}

.provider-card__content {
  padding: 12px;
}

.provider-card__info {
  margin-bottom: 8px;
}

.provider-card__category {
  font-size: 0.75rem;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.provider-card__title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.4;
  min-height: 40px;
  max-height: 48px;
  margin: 0;
  color: #333;
}

/* Mobile */
@media (max-width: 640px) {
  .provider-card__image {
    height: 120px;
  }

  .provider-card__content {
    padding: 10px;
  }

  .provider-card__title {
    font-size: 0.85rem;
    min-height: 40px;
    max-height: 40px;
  }

  .provider-card__category {
    font-size: 0.7rem;
  }
}
</style>
